
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trains/reviews/[id]",
      function () {
        return require("private-next-pages/trains/reviews/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trains/reviews/[id]"])
      });
    }
  